'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
var initialState = null;
export default handleActions(_defineProperty({}, ActionTypes.SHOW_USER_MESSAGE, function (state, action) {
  var userMessage = action.userMessage;
  return userMessage;
}), initialState);